import { getFirebaseToken } from '../firebase';  // Importation de la fonction depuis firebase.js

const BackEndUrl = process.env.REACT_APP_BACKEND_URL;  // URL du backend depuis les variables d'environnement
export const sendEmail = async (recipientEmail, subject, message) => {
    try {
      console.log("BackEndUrl :", `${BackEndUrl}api/sendEmail`);  // Vérifiez la sortie pour vous assurer qu'elle n'est pas undefined
      
      const token = await getFirebaseToken();  // Récupérer le token d'ID Firebase
      if (!token) {
        console.error('Token Firebase manquant');
        return "Token Firebase manquant. Vous devez être authentifié.";
      }
  
      const response = await fetch(`${BackEndUrl}/api/sendEmail`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}`,  // Ajouter le token dans les en-têtes
        },
        body: JSON.stringify({
          to: recipientEmail,
          subject,
          message,
        }),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        return data; // Renvoie la réponse en cas de succès
      } else {
        throw new Error(data.message || 'Erreur lors de l\'envoi de l\'email');
      }
    } catch (error) {
      throw new Error('Erreur lors de l\'envoi de l\'email : ' + error.message);
    }
  };
  